/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { Download, Warning } from "@mui/icons-material";
import PageLoading from "./PageLoading";
import ifLogoWhite from "../assets/img/if-logo.png";

const OpenDocuments = ({
  document,
  name,
  mimeType,
  downloadable,
  height,
  width,
  GeneralDownload,
  type,
  DownloadBase64,
  card,
  specialName,
    imgClassName,
    planeImage,
}) => {

  const [loading, setLoading] = useState(false);
  const [autoDownloading, setAutoDownloading] = useState(false);
  const [data, setData] = useState();
  const downloadData = async () => {
    setAutoDownloading(true);
    const res = await DownloadBase64(document, name, type, mimeType, specialName);
    if (res) {
      setData(res);
    }
    setAutoDownloading(false);
  };

  useEffect(() => {
    downloadData().then();
  }, [type, document]);

  const button = downloadable && (
    <div className={"text-center p-3"}>
      {loading ? null : (
        <Button
          startIcon={<Download />}
          onClick={async () => {
            setLoading(true);
            await GeneralDownload(document, mimeType, specialName, type, name);
            setLoading(false);
          }}
        >
          Download Document
        </Button>
      )}
    </div>
  );

  const innerContent = mimeType?.split("/")[0] === "video" ? (
      <>
        <video width="100%" height="80%" controls>
          <source src={data} />
        </video>
        {button}
      </>
  ) : mimeType?.split("/")[0] === "image" ? (
      <>
        <img src={data} className={imgClassName} height={height} width={width ?? "100%"} alt={""} />
        {button}
      </>
  ) : mimeType?.split("/")[1] === "pdf" ? (
      data ? (
          <div className="text-center">
            <object
                data={`${data}#view=Fit&toolbar=0&statusbar=0&messages=0&navpanes=0&scrollbar=0`}
                type="application/pdf"
                style={{ display: "inline-block" }}
                width={width ?? "60%"}
                height={height ?? "842"}
            >
              <embed src={data} type="application/pdf" />
            </object>
            {button}
          </div>
      ) : (
          <div className={'text-center p-5'}>
            <Typography variant={"h4"}>Document not found !!</Typography>
            <Warning color={'error'} fontSize={'large'} />
          </div>
      )
  ) : loading ? null : (
      <div className={'text-center p-6'}>
        <Warning color={'warning'} fontSize={'large'} />
        <Typography>File view is not available, download it to view it on your device</Typography>
        <Button
            onClick={async () => {
              setLoading(true);
              await GeneralDownload(document, mimeType, specialName);
              setLoading(false);
            }}
            startIcon={<Download />}>
          Download Document
        </Button>
      </div>
  );

  const content = planeImage ? innerContent :
    <div>
      {innerContent}
    </div>;

  return autoDownloading ? null : card ? (
    <Card className={"mb-3 shadow-sm"}>
      <CardContent>{content}</CardContent>
    </Card>
  ) : (
    planeImage ? content : <div className={"mb-3"}>{content}</div>
  );
};

export default connect(null, mapDispatchToProps)(OpenDocuments);
